var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8188 4.69346C17.8188 7.12351 15.8489 9.09346 13.4188 9.09346C10.9887 9.09346 9.0188 7.12351 9.0188 4.69346C9.0188 2.2634 10.9887 0.293457 13.4188 0.293457C15.8489 0.293457 17.8188 2.2634 17.8188 4.69346Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4188 8.09346C15.2966 8.09346 16.8188 6.57123 16.8188 4.69346C16.8188 2.81569 15.2966 1.29346 13.4188 1.29346C11.541 1.29346 10.0188 2.81569 10.0188 4.69346C10.0188 6.57123 11.541 8.09346 13.4188 8.09346ZM13.4188 9.09346C15.8489 9.09346 17.8188 7.12351 17.8188 4.69346C17.8188 2.2634 15.8489 0.293457 13.4188 0.293457C10.9887 0.293457 9.0188 2.2634 9.0188 4.69346C9.0188 7.12351 10.9887 9.09346 13.4188 9.09346Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6189 21.0934C16.6189 22.8607 15.1862 24.2934 13.4189 24.2934C11.6516 24.2934 10.2189 22.8607 10.2189 21.0934C10.2189 19.3261 11.6516 17.8934 13.4189 17.8934C15.1862 17.8934 16.6189 19.3261 16.6189 21.0934Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4189 23.2934C14.6339 23.2934 15.6189 22.3085 15.6189 21.0934C15.6189 19.8784 14.6339 18.8934 13.4189 18.8934C12.2038 18.8934 11.2189 19.8784 11.2189 21.0934C11.2189 22.3085 12.2038 23.2934 13.4189 23.2934ZM13.4189 24.2934C15.1862 24.2934 16.6189 22.8607 16.6189 21.0934C16.6189 19.3261 15.1862 17.8934 13.4189 17.8934C11.6516 17.8934 10.2189 19.3261 10.2189 21.0934C10.2189 22.8607 11.6516 24.2934 13.4189 24.2934Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9188 18.2935V8.29346H13.9188V18.2935H12.9188Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21885 21.0936C7.21885 22.8609 5.78616 24.2936 4.01885 24.2936C2.25154 24.2936 0.818848 22.8609 0.818848 21.0936C0.818848 19.3262 2.25154 17.8936 4.01885 17.8936C5.78616 17.8936 7.21885 19.3262 7.21885 21.0936Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01885 23.2936C5.23387 23.2936 6.21885 22.3086 6.21885 21.0936C6.21885 19.8785 5.23387 18.8936 4.01885 18.8936C2.80382 18.8936 1.81885 19.8785 1.81885 21.0936C1.81885 22.3086 2.80382 23.2936 4.01885 23.2936ZM4.01885 24.2936C5.78616 24.2936 7.21885 22.8609 7.21885 21.0936C7.21885 19.3262 5.78616 17.8936 4.01885 17.8936C2.25154 17.8936 0.818848 19.3262 0.818848 21.0936C0.818848 22.8609 2.25154 24.2936 4.01885 24.2936Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6188 21.0936C19.6188 22.8609 21.0515 24.2936 22.8188 24.2936C24.5861 24.2936 26.0188 22.8609 26.0188 21.0936C26.0188 19.3262 24.5861 17.8936 22.8188 17.8936C21.0515 17.8936 19.6188 19.3262 19.6188 21.0936Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8188 23.2936C21.6038 23.2936 20.6188 22.3086 20.6188 21.0936C20.6188 19.8785 21.6038 18.8936 22.8188 18.8936C24.0338 18.8936 25.0188 19.8785 25.0188 21.0936C25.0188 22.3086 24.0338 23.2936 22.8188 23.2936ZM22.8188 24.2936C21.0515 24.2936 19.6188 22.8609 19.6188 21.0936C19.6188 19.3262 21.0515 17.8936 22.8188 17.8936C24.5861 17.8936 26.0188 19.3262 26.0188 21.0936C26.0188 22.8609 24.5861 24.2936 22.8188 24.2936Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6001 13.5935V12.5935H13.8189V13.5935H4.6001V18.2935H3.6001V13.5935Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3501 13.5935V12.5935H13.8188V13.5935H22.3501V18.2935H23.3501V13.5935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6d0d5c44949746caa39b064a33c70a79.svg";
export { ForwardRef as ReactComponent };